// src/components/home/HeroBanner.jsx
import React from "react";

const HeroBanner = ({ banner }) => {
  if (!banner) {
    return (
      <div className="h-48 sm:h-56 md:h-72 lg:h-96 bg-gray-300 animate-pulse flex items-center justify-center">
        <span className="text-gray-500">Loading banner...</span>
      </div>
    );
  }

  const {
    title,
    img,
  } = banner;

  const backgroundImageUrl = img?.url ? `${img.url}` : null;
  const titleLines = String(title || "").split("\\n");

  return (
    <section
      className="relative h-48 sm:h-56 md:h-72 lg:h-96 xl:h-[450px] bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: backgroundImageUrl
          ? `url(${backgroundImageUrl})`
          : "linear-gradient(135deg, #0076be 0%, #48bf91 100%)",
      }}
    >
      {/* Content overlay */}
      <div className="absolute inset-0 flex items-end justify-start px-4 pb-4 sm:px-8 sm:pb-8 md:px-16 md:pb-10 lg:px-24 lg:pb-12">
        <div className="hero-banner-title-wrap text-left rounded-lg bg-black/25 px-4 py-3 sm:px-5 sm:py-4 md:px-6 md:py-5 max-w-sm sm:max-w-lg md:max-w-2xl lg:max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold italic leading-[1.2] text-white drop-shadow-sm">
            {titleLines.map((line, index) => (
              <span
                key={`${line}-${index}`}
                className={index === 0 ? "block" : "block mt-4"}
              >
                {line}
              </span>
            ))}
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
